// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a847d085","909":"87a40b71"}[chunkId] + ".chunk.js";
};